var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      staticClass: "user-confirmation-needed-modal",
      attrs: {
        title: "Confirm Your Selection",
        size: "lg",
        "no-close-on-esc": true,
        "no-close-on-backdrop": true,
        "hide-header-close": true,
        "ok-title": "Okay",
        "ok-variant": "orange"
      },
      on: { cancel: () => _vm.undo() },
      model: {
        value: _vm.userConfirmationNeeded,
        callback: function($$v) {
          _vm.userConfirmationNeeded = $$v
        },
        expression: "userConfirmationNeeded"
      }
    },
    [
      _c("your-selection"),
      _vm._v(" "),
      _c("div", { staticClass: "px-4" }, [
        _vm.additionAffectedChromeOptions.length > 0
          ? _c("div", { staticClass: "additions my-3" }, [
              _c("p", [
                _c("strong", [
                  _vm._v(
                    "To " +
                      _vm._s(_vm.isAddition ? "add" : "remove") +
                      " that feature,\n                    you must also add:"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "options" },
                _vm._l(_vm.additionAffectedChromeOptions, function(option) {
                  return _c(
                    "div",
                    {
                      key: option.chromeOptionCode,
                      staticClass: "option d-flex justify-content-between"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "label" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.getName(option)) }
                          }),
                          _vm._v(" "),
                          _vm.hasDescription(option)
                            ? _c("i", {
                                staticClass: "ion-ios-information-outline",
                                attrs: {
                                  id: "popover-" + option.chromeOptionCode,
                                  tabindex: "-1",
                                  "aria-hidden": "true"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasDescription(option)
                            ? _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "popover-" + option.chromeOptionCode,
                                    triggers: "click blur"
                                  }
                                },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-between"
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "name",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getName(option)
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "cost" }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm._f("numeral")(
                                                  _vm.getCost(option),
                                                  "$0,0"
                                                )
                                              ) +
                                              "\n                                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "description-popover",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getDescription(option)
                                      )
                                    }
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "cost" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("numeral")(_vm.getCost(option), "$0,0")
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.deletionAffectedChromeOptions.length > 0
          ? _c("div", { staticClass: "deletions my-3" }, [
              _c("p", [
                _c("strong", [
                  _vm._v(
                    "To " +
                      _vm._s(_vm.isAddition ? "add" : "remove") +
                      " that feature,\n                    you must also remove:"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "options" },
                _vm._l(_vm.deletionAffectedChromeOptions, function(option) {
                  return _c(
                    "div",
                    {
                      key: option.chromeOptionCode,
                      staticClass: "option d-flex justify-content-between"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "label" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.getName(option)) }
                          }),
                          _vm._v(" "),
                          _vm.hasDescription(option)
                            ? _c("i", {
                                staticClass: "ion-ios-information-outline",
                                attrs: {
                                  id: "popover-" + option.chromeOptionCode,
                                  tabindex: "-1",
                                  "aria-hidden": "true"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasDescription(option)
                            ? _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "popover-" + option.chromeOptionCode,
                                    triggers: "click blur"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "description-popover",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getDescription(option)
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "cost" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("numeral")(_vm.getCost(option), "$0,0")
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }